import {
    GET_SAVE_RECEIVING_BRANCH,
    SET_SAVE_RECEIVING_BRANCH
} from "./FleetTransferReceivingBranchType"

const getSaveReceivingBranch = (saveReceivingBranch: any) => ({
    type: GET_SAVE_RECEIVING_BRANCH,
    saveReceivingBranch
})

const setSaveReceivingBranch = (receivingBranchValues: any) => ({
    type: SET_SAVE_RECEIVING_BRANCH,
    receivingBranchValues: receivingBranchValues
})

export {
    getSaveReceivingBranch,
    setSaveReceivingBranch
}